// extracted by mini-css-extract-plugin
export default {"container":"CopyLinkBox_container__NdrCU","urlBox":"CopyLinkBox_urlBox__S1Zgk","copyButton":"CopyLinkBox_copyButton__hngGC"};